import { API_ENDPOINTS } from "../../src/constants";
import { apiClient } from './apiClient';

export interface SendMessageInput {
  chatbotId: string;
  tenantId: string;
  userId: string;
  message: string;
  conversationId?: string;
  viewType?: string;
  userTimezone?: string;
  /** Persistent browser/visitor id (memory platform) — see utils/visitorIdentity. */
  anonymousId?: string;
  /** Embed/host-supplied extra context (e.g. externalUserId, a lead-capture form submission).
   *  Passed through to the backend unvalidated — see core-ms's chat routes.ts schema. */
  additionalInputParams?: Record<string, any>;
}

export async function sendMessageApi(data: SendMessageInput, authenticate: boolean = false) {
  const result = await apiClient.post(API_ENDPOINTS.CHAT.SEND_MESSAGE, data, {
    authenticate,
    timeoutMs: 120000,  // 120 seconds
  });
  return result as any;
}

// streaming variant
export async function sendMessageStreamApi(
  data: SendMessageInput,
  authenticate: boolean = false
) {
  const { response } = await apiClient.postStream(API_ENDPOINTS.CHAT.SEND_MESSAGE, data, {
    authenticate,
    timeoutMs: 120000,
  });
  return response; // native fetch Response
}
